export default {
  loading: false,
  error: null,
  data: null,
};
